import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isDarkTheme: false,
        theme: 'theme-light',
        // baseUrl: 'http://47.99.160.141:1688'
        baseUrl: 'https://47.99.160.141:1688'
        // baseUrl: 'https://serve.maluyao.top:1688'
        // baseUrl: 'http://127.0.0.1:1688'
    },
    actions: {
        toggleTheme(context, theme) {
            context.state.isDarkTheme = theme
            context.state.theme  = !context.state.isDarkTheme ? 'theme-light' : 'theme-dark'
            document.body.className = theme
        },
        setTheme({ commit }, theme) {
            commit('SET_THEME', theme)
        }
    },
    getters: {
        currentTheme: state => state.theme,
        isDarkTheme: state => state.isDarkTheme
    }
})
